import DynamicTooltip from './DynamicTooltip';

export default DynamicTooltip;
